module.exports = __webpack_public_path__ + "static/media/logo-dxc.756a28b8.png";